import home from "./home.component";
import homeUrls from "./home.urls";
import HomeTransforms from "./home.transforms";

const homeModule = angular
  .module("app.components.home", [])
  .component("homePage", home)
  .service("HomeTransforms", HomeTransforms)
  .config(homeUrls);

export default homeModule;



// WEBPACK FOOTER //
// ./src/pages/home/home.module.js